import { createApiEffect } from '@/features/api/common/create-api-effect'
import { ExportAssignmentQueryParams } from '@/features/api/assignment/types/types'

export const exportApplicationsCoursesListFx = createApiEffect<
  ExportAssignmentQueryParams,
  { task_id: string }
>({
  requestMapper: (query) => ({
    method: 'GET',
    url: '/api/ticket-app/course-ticket/list/export/',
    query,
  }),
})
